import { Controller } from '@hotwired/stimulus';

import showFlash from '~/utils/flash';

// Publishing is an action on the page as it was last saved, so a builder still
// holding unsaved edits would put the older version live and leave the editor
// looking at a screen the visitor never gets: a page type picked but not saved
// publishes as the type on record, and reports the fields that type demands.
// The button stops there and asks for a save rather than publishing behind the
// editor's back. The preview renders that same last-saved version, so the link
// to it waits on a save the same way.
export default class extends Controller {
  static values = {
    formId: String,
    message: {
      type: String,
      default: 'Save the page first. Publishing uses the version that was last saved, so the changes on screen would be left behind.'
    }
  };

  connect() {
    this.builderForm = document.getElementById(this.formIdValue);
    this.edited = false;
    this.markEdited = () => {
      this.edited = true;
    };

    // The rich text editor edits markup of its own inside the form rather than
    // the textarea it replaced, so listening on the form catches the body along
    // with every plain field.
    this.builderForm?.addEventListener('input', this.markEdited);
    this.builderForm?.addEventListener('change', this.markEdited);
  }

  disconnect() {
    this.builderForm?.removeEventListener('input', this.markEdited);
    this.builderForm?.removeEventListener('change', this.markEdited);
    this.builderForm = null;
  }

  // The click is what is stopped: by the time the form submits, Turbo has
  // already taken the request over.
  confirm(event) {
    if (!this.edited) {
      return;
    }

    event.preventDefault();
    showFlash(this.messageValue, { type: 'alert' });
  }
}
